import { render, staticRenderFns } from "./KasbonExternal.vue?vue&type=template&id=3c5b7849"
import script from "./KasbonExternal.vue?vue&type=script&lang=js"
export * from "./KasbonExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports